/* ==========================================================================

 CreateProjectView

 Author:      Dave Taylor (http://davetayls.me)
 Description: Opens modal to create a new project and redirects when success

 ========================================================================== */
'use strict';

var Backbone = require('backbone'),
  $ = require('jquery'),
  config = require('../../js/config'),
  mediator = require('../../js/mediator'),
  PointyModalView = require('../../js/components/PointyModalView'),
  CreateProjectModalView = require('./CreateProjectModalView'),
  Tooltip = require('../../js/components/Tooltip'),
  CreateProjectView = Backbone.View.extend({

    initialize: function(options) {
      options = options || {};
      this.copyFromProject = options.copyFromProject;

      this.initComponents();
      mediator.on(config.events.designCenter.projectCreatedOnServer, this.redirectToProject, this);

      this.listenTo(this.pointy, 'tooltip:close', this.onCloseCreateProjectPopup);
      this.listenTo(this.modalView, 'createProject:cancel', this.closeCreateProjectPopup);

    },

    copyFromProject: null,

    layoutBreakpoint: 1024,

    events: {
      click: 'openCreateProjectPopup'
    },

    initComponents: function() {
      this.modalView = new CreateProjectModalView({
        copyFromProject: this.copyFromProject
      });
      this.modalView.render();
      if (this.$el.is('[title]')) {
        this.tooltip = new Tooltip({
          el: this.el
        });
      }
      this.pointy = new PointyModalView({
        el: this.el,
        offsetX: 4,
        contentCloning: false,
        content: this.modalView.$el,
        multiple: true
      });
    },

    openCreateProjectPopup: function(e) {
      e.preventDefault();
      this.pointy.open();

      this.currentLayout = (window.innerWidth >= this.layoutBreakpoint) ? 'desktop' : 'phablet';
      mediator.on(config.events.ui.resize, this.onBreakpoint, this);
    },

    onBreakpoint: function() {
      // Hide tooltip on change from mobile/tablet to desktop (phablet to desktop) and the other way round
      var newLayout = (window.innerWidth >= this.layoutBreakpoint) ? 'desktop' : 'phablet',
        hasLayoutChanged = (this.currentLayout !== newLayout);

      if (hasLayoutChanged) {
        this.closeCreateProjectPopup();
        this.currentLayout = newLayout;
      }
    },

    closeCreateProjectPopup: function() {
      this.pointy.close();
      this.currentLayout = null;
      mediator.off(config.events.ui.resize, this.onBreakpoint);
    },

    onCloseCreateProjectPopup: function() {
      // Sending event to the CreateProjectModalView to reset the create project form
      this.modalView.trigger('createProjectModal:closed');
    },

    redirectToProject: function(projectModel) {
      if (projectModel.get('name') === this.modalView.currentProjectName) {
        this.closeCreateProjectPopup();
        mediator.trigger(config.events.requestPageReload, projectModel.get('uri'));
      }
    }

  }, {
    create: function($parent) {
      $parent.find('.js-createProject').each(function(n, el) {
        new CreateProjectView({
          el: el
        });
      });
      $parent.find('.js-copyProject').each(function(n, el) {
        new CreateProjectView({
          el: el,
          copyFromProject: $(el).data('project')
        });
      });
    }
  });

module.exports = CreateProjectView;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/CreateProjectView.js